  <!-- Processing tab -->
  
   <!-- Quick guides icon -->
  <div class="fdm-sidebar-toolbar fdm-buttons clearfix">
    <button *ngIf="permissions?.can?.show_intro_tour?.site_settings"
          class="fdm-linked pointer fdm-tools-button fdm-help float-right" 
        [matTooltip]="'NAV.QUICK_GUIDES' | translate" (click)="uiManager.toggleQuickGuidePopup('map', true)">
      <fa-icon icon="question-circle"></fa-icon>
    </button>
  </div>
  
  <div class="fdm-sidebar-tabs-body" style="padding-top:20px;">

<!-- <textarea style="width:100%;height:170px;font-size:9px;">{{ this.mapService.scenes | json }}</textarea>
<textarea style="width:100%;height:170px;font-size:10px;">{{ this.mapService.sceneTransforms | json }}</textarea> -->

  <ul class="fdm-sidebar-list-simple fdm-sidebar-list-tight">

    <!-- <li *ngIf="activeJobs.length > 0"> 
      Jobs ({{ activeJobs.length}})
      <div *ngFor="let j of activeJobs">
        [{{ j.name }}]
        !-- <textarea style="width:100%;height:170px;font-size:10px;">{{ j | json }}</textarea> --
      </div>
    </li> -->

      <li *ngFor="let category of categories | keyvalue; let i = index;" class="fdm-sidebar-scene" [ngClass]="{'text-default':loading}">

        <!-- if not the current one, just show name -->
        <div class="fdm-sidebar-scene-header">

          <fa-icon class="fdm-silent-icon" icon="caret-down"></fa-icon>
          {{ category.key }}

        </div>

        <!-- [{{ currentlySelected }}] -->

        <div class="fdm-sidebar-scene-body" style="margin-bottom:5px;">

          <ul class="fdm-sidebar-scene-layers" *ngIf="!loading">

            <li  *ngFor="let item of category.value | keyvalue; let j = index;">
              <div class="fdm-sidebar-scene-layer" style="padding-left:10px;" [class.selected]="item.value.id == currentlySelected" (click)="currentlySelected = item.value.id">

                <!-- <textarea style="width:100%;height:170px;font-size:10px;">{{ item | json }}</textarea> -->
                
                <!-- <div class="fdm-layer-tools" *ngIf="!editing"></div> -->

                <!-- [{{ item.value.id }}] -->
                <div class="fdm-layer-title" style="width:80%">

                  <!-- <span class="fdm-checkboxes">
                    <input [id]="'plugin_' + item.key" type="checkbox" class="fdm-checkbox" />
                    <label [for]="'plugin_' + item.key"></label>
                  </span> -->

                  <span>
                    <fa-icon class="fdm-silent-icon" [icon]="item.value.icon ? item.value.icon : 'plug'"></fa-icon>
                      {{ item.value.name }} <a [id]="'guide-processing-'+item.value.uid" class="fdm-linked" 
                      [routerLink]="item.value.mode == 'job' ? ['proc',item.value.mode,item.value.id,'new'] : ['proc',item.value.mode,item.value.id]">
                      <fa-icon icon="plus-circle"></fa-icon>
                    </a>
                    <!-- <ng-container *ngIf="fourD.activeTeam && ( this.fourD.activeTeam['isDomain'] || this.fourD.activeTeam['uid'] == 'test' )">
                      <fa-icon *ngIf="item.value.jobTypeRef && item.value.jobTypeRef.baseTransform" class="fdm-linked" style="margin-left:5px;" (click)="editWorkflow(item.value)" icon="briefcase"></fa-icon>
                    </ng-container> -->
                    
                  </span>
                  
                  <!-- <span *ngIf="item.value.mode != 'job'">
                    <fa-icon class="fdm-silent-icon" [icon]="item.value.icon ? item.value.icon : 'plug'"></fa-icon>
                    {{ item.value.name }} <a [id]="'guide-processing-'+item.value.uid" class="fdm-linked" [routerLink]="['proc',item.value.mode,item.value.id]"><fa-icon icon="plus"></fa-icon></a>
                  </span> -->

                </div>

                <!-- clear the floats! -->
                <div class="clearfix"></div>

                <div class="fdm-sidebar-scene-layers" style="padding-left:22px;" *ngIf="item.value.items && item.value.items.length > 0">
                  <span class="fdm-linked" (click)="item.value['show'] = ! item.value['show']">
                    <fa-icon *ngIf="!item.value['show']" class="fdm-silent-icon" icon="caret-right" matTooltip="{{ 'MAP.LAYERS.SEE_FILES' | translate }}"></fa-icon>
                    <fa-icon *ngIf="item.value['show']" class="fdm-silent-icon" icon="caret-down" matTooltip="{{ 'MAP.LAYERS.HIDE_FILES' | translate }}"></fa-icon>
                    {{ 'MAP.PHOTOGRAM.ACTIVE_JOBS' | translate }} ({{ item.value.items.length }})
                  </span>
                  <ng-container *ngIf="item.value['show']">
                    <div class="pl-4 mt-2" *ngFor="let i of item.value.items">
                      <a [routerLink]="['proc',item.value.mode,item.value.id,i.id]">{{ i.name }} </a> 
                      <fa-icon *ngIf="runningJobs['' + i.id]" icon="circle-notch" spin="true"></fa-icon>
                      <i *ngIf="i.status && !runningJobs['' + i.id]">{{ i.status }}</i>
                    </div>
                  </ng-container>
                </div>             
              </div>
            </li>
          </ul>
        </div>
      </li>
  </ul>
</div>

<div id="workflow-popover" class="fdm-floatbar" *ngIf="editWorkflowSelected">

    <div class="fdm-sidebar-header fdm-sidebar-header-primary fdm-buttons fdm-shadow clearfix">
      <li class="fdm-linked fdm-options-button pointer" (click)="editWorkflowSelected = null">
        <fa-icon icon="times"></fa-icon>
      </li>
      <li class="fdm-linked fdm-options-button pointer" (click)="editWorkflowSelected = null">
        <fa-icon icon="save"></fa-icon>
      </li>
      <h2>Edit workflow</h2>
    </div>

    <div style="width:100%;height:100%;padding:0;margin:0;">
      <table style="width:100%;height:95%;margin:0;padding:0;">
        <tr>
          <td style="vertical-align:top;width:60%;" rowspan="2">
            <div style="padding:15px;height:100%;overflow-y:scroll;">
              <app-edit-workflow *ngIf="editWorkflowSelected" [context]="this" [item]="editWorkflowSelected"></app-edit-workflow>
            </div>
          </td>
          <td style="vertical-align:top;text-align:center;background-color:#eee;" colspan="2">

            <div style="padding:15px;">
              
              <b style="font-size:15px;margin-right:6px;">Preview</b>

              <ng-container *ngIf="editWorkflowSelected['worflow-template'] && editWorkflowSelected['worflow-template'].length">

                Current step <select class="section-item-option" [(ngModel)]="previewStep" (change)="pluginCache = null">
                    <option *ngFor="let option of editWorkflowSelected['worflow-template']" [value]="option.step">{{ option.step + 1 }}</option>
                </select>

                Current state <select class="section-item-option" [(ngModel)]="previewState" (change)="pluginCache = null">
                    <option *ngFor="let option of states" [value]="option.id">{{ option.label }}</option>
                </select>

                <div style="text-align:left;margin-top:25px;margin-bottom:25px;background-color:#eee;">

                  <div *ngFor="let step of editWorkflowSelected['worflow-template']">

                    <ng-container *ngIf="step.step !== previewStep">
                      <div  *ngIf="!step.hideHeader" style="color:#fff;padding:10px;margin:3px;">
                        <h4>Step {{ (step.step+1) }}</h4>
                      </div>
                    </ng-container>
                    
                    <ng-container *ngIf="step.step == previewStep">

                      <div  *ngIf="!step.hideHeader" style="background-color:skyblue;color:#fff;padding:10px;margin:3px;">
                        <h4>Step {{ (step.step+1) }}</h4>
                      </div>
    
                      <ng-container *ngFor="let state of step.states">
                        <ng-container *ngIf="state.id == previewState">
    
                          <div id="workflow-preview" *ngIf="populatePluginController(state.items)">
                            <plugin-ui [plugin]="previewPluginController" [context]="this"></plugin-ui>
                          </div>
    
                        </ng-container>
                      </ng-container>
    
                    </ng-container>
    
                  </div>
                </div>
              </ng-container>

            </div>

          </td>
        </tr>
        <tr>
          <td style="vertical-align:bottom;height:220px;background-color:#eee;">
            <div style="padding:15px;">
              <div style="text-align:center;">
                <b style="font-size:15px;">All text tokens</b>
              </div>
              <textarea style="width:100%;height:200px;font-size:9px;background-color:#fed;border:none;padding:4px;">{{ languageJSON | json }}</textarea>
            </div>
          </td> 
          <td style="vertical-align:bottom;height:220px;background-color:#eee;">
            <div style="padding:15px;">
              <div style="text-align:center;">
                <b style="font-size:15px;">Config code</b>
              </div>
              <textarea style="width:100%;height:200px;font-size:9px;background-color:#fed;border:none;padding:4px;">{{ editWorkflowSelected['worflow-template'] | json }}</textarea>
            </div>
          </td>
        </tr>
      </table>

    </div>


</div>
